// URGENTE toggle pill: OFF = dim amber, ON = bright amber with glow.
// Maps to task.priority: 5 when urgent, 3 when not.
export default function UrgentPill({ urgent, onChange, testId }) {
  const onClick = () => onChange && onChange(!urgent);
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      aria-pressed={urgent ? "true" : "false"}
      title={urgent ? "URGENTE attiva — click per disattivare" : "Marca come URGENTE"}
      className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold uppercase tracking-wider transition-all border ${
        urgent
          ? "bg-amber-500/20 border-amber-400/60 text-amber-300 shadow-[0_0_10px_-2px_rgba(245,158,11,0.55)]"
          : "bg-amber-500/[0.06] border-amber-500/20 text-amber-500/45 hover:text-amber-400/70 hover:bg-amber-500/[0.1]"
      }`}
    >
      <span
        className={`inline-block h-1.5 w-1.5 rounded-full ${
          urgent ? "bg-amber-300 shadow-[0_0_8px_rgba(245,158,11,0.8)]" : "bg-amber-500/40"
        }`}
      />
      Urgente
    </button>
  );
}
